export const test = {
  clicksCount: null,
  leadsCount: null,
  earnings: null,
  earningsTotal: null,
  filter: {
    date: {
      from: '',
      to: '',
    },
    countryCode: '',
    adType: '',
    publisherId: '',
    appId: '',
  },
  statistics: {},
  allCountries: {
    items: [],
    sort: {
      key: 'impressionsCount',
      order: -1,
    },
  },
  allCampaigns: {
    items: [],
    sort: {
      key: 'numberOfServed',
      order: -1,
    },
  },
  isFetching: false,
  fetchingErrorMessages: [],
  activeFetchingCounter: 0,
};

export const initial = {
  clicksCount: null,
  leadsCount: null,
  earnings: null,
  earningsTotal: null,
  filter: {
    date: {
      from: '',
      to: '',
    },
    countryCode: '',
    adType: '',
    publisherId: '',
    appId: '',
  },
  statistics: {},
  allCountries: {
    items: [],
    sort: {
      key: 'impressionsCount',
      order: -1,
    },
  },
  allCampaigns: {
    items: [],
    sort: {
      key: 'numberOfServed',
      order: -1,
    },
  },
  isFetching: false,
  fetchingErrorMessages: [],
  activeFetchingCounter: 0,
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/impressionsReports.state.js
 **/